import Vue from "vue";
import Vuex from "vuex";
import { GoogleAuthProvider, signInWithRedirect, signOut } from "firebase/auth";
import { Timestamp, collection, query, where, getDocs, addDoc, updateDoc, deleteDoc, setDoc, getDoc, doc } from "firebase/firestore";
import { db, auth } from "../main";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    login_user: null,
    drawer: false,
    categories: [],
    items: [],
    locations: [],
    inventories: [],
    histories: [],
  },
  mutations: {
    toggleSideMenu(state) {
      state.drawer = !state.drawer;
    },
    setLoginUser(state, user) {
      state.login_user = user;
    },
    deleteLoginUser(state) {
      state.login_user = null;
    },
    addCategory(state, { id, category }) {
      category.id = id;
      state.categories.push(category);
      state.categories.sort(function (a, b) {
        let nameA = a.name.toUpperCase();
        let nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateCategory(state, category) {
      const index = state.categories.findIndex((element) => element.id === category.id);
      state.categories[index].name = category.name;
      state.categories[index].color = category.color;
      state.categories.sort(function (a, b) {
        let nameA = a.name.toUpperCase();
        let nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    deleteCategory(state, id) {
      const index = state.categories.findIndex((element) => element.id === id);
      state.categories.splice(index, 1);
    },
    addItem(state, { id, item }) {
      const element = {
        id: id,
        category: {
          id: item.category.id,
          name: item.category.name,
          color: item.category.color,
        },
        name: item.name,
        expirationDateManagement: item.expirationDateManagement,
        unitPurchasePriceManagement: item.unitPurchasePriceManagement,
      };
      state.items.push(element);
      state.items.sort(function (a, b) {
        let nameA = a.category.name.toUpperCase() + a.name.toUpperCase();
        let nameB = b.category.name.toUpperCase() + b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    addItemFromDB(state, { id, item }) {
      const element = {
        id: id,
        category: {
          id: item.categoryId,
          name: item.categoryName,
          color: item.categoryColor,
        },
        name: item.name,
        expirationDateManagement: item.expirationDateManagement,
        unitPurchasePriceManagement: item.unitPurchasePriceManagement,
      };
      state.items.push(element);
      state.items.sort(function (a, b) {
        let nameA = a.category.name.toUpperCase() + a.name.toUpperCase();
        let nameB = b.category.name.toUpperCase() + b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateItem(state, item) {
      const index = state.items.findIndex((element) => element.id === item.id);
      state.items[index].category.id = item.category.id;
      state.items[index].category.name = item.category.name;
      state.items[index].category.color = item.category.color;
      state.items[index].name = item.name;
      state.items[index].expirationDateManagement = item.expirationDateManagement;
      state.items[index].unitPurchasePriceManagement = item.unitPurchasePriceManagement;
      state.items.sort(function (a, b) {
        let nameA = a.category.name.toUpperCase() + a.name.toUpperCase();
        let nameB = b.category.name.toUpperCase() + b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateItemFromCategory(state, { id, category }) {
      const index = state.items.findIndex((element) => element.id === id);
      state.items[index].category.name = category.name;
      state.items[index].category.color = category.color;
      state.items.sort(function (a, b) {
        let nameA = a.category.name.toUpperCase() + a.name.toUpperCase();
        let nameB = b.category.name.toUpperCase() + b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    deleteItem(state, id) {
      const index = state.items.findIndex((element) => element.id === id);
      state.items.splice(index, 1);
    },
    addLocation(state, { id, location }) {
      location.id = id;
      state.locations.push(location);
      state.locations.sort(function (a, b) {
        let nameA = a.name.toUpperCase();
        let nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateLocation(state, location) {
      const index = state.locations.findIndex((element) => element.id === location.id);
      state.locations[index].name = location.name;
      state.locations.sort(function (a, b) {
        let nameA = a.name.toUpperCase();
        let nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    deleteLocation(state, id) {
      const index = state.locations.findIndex((element) => element.id === id);
      state.locations.splice(index, 1);
    },
    addInventory(state, { id, inventory }) {
      const element = {
        id: id,
        entryDate: inventory.entryDate,
        item: {
          id: inventory.item.id,
          category: {
            id: inventory.item.category.id,
            name: inventory.item.category.name,
            color: inventory.item.category.color,
          },
          name: inventory.item.name,
          expirationDateManagement: inventory.item.expirationDateManagement,
          unitPurchasePriceManagement: inventory.item.unitPurchasePriceManagement,
        },
        location: {
          id: inventory.location.id,
          name: inventory.location.name,
        },
        expirationDate: inventory.expirationDate,
        unitPurchasePrice: inventory.unitPurchasePrice,
        store: inventory.store,
        remainingQty: inventory.remainingQty,
        additionalQty: inventory.additionalQty,
      };
      state.inventories.push(element);
      state.inventories.sort(function (a, b) {
        let nameA = a.location.name.toUpperCase() + a.item.category.name.toUpperCase() + a.item.name.toUpperCase() + a.expirationDate.toUpperCase();
        let nameB = b.location.name.toUpperCase() + b.item.category.name.toUpperCase() + b.item.name.toUpperCase() + b.expirationDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    addInventoryFromDB(state, { id, inventory }) {
      const element = {
        id: id,
        entryDate: inventory.entryDate,
        item: {
          id: inventory.itemId,
          category: {
            id: inventory.categoryId,
            name: inventory.categoryName,
            color: inventory.categoryColor,
          },
          name: inventory.itemName,
          expirationDateManagement: inventory.expirationDateManagement,
          unitPurchasePriceManagement: inventory.unitPurchasePriceManagement,
        },
        location: {
          id: inventory.locationId,
          name: inventory.locationName,
        },
        expirationDate: inventory.expirationDate,
        unitPurchasePrice: inventory.unitPurchasePrice,
        store: inventory.store,
        remainingQty: inventory.remainingQty,
        additionalQty: inventory.additionalQty,
      };
      state.inventories.push(element);
      state.inventories.sort(function (a, b) {
        let nameA = a.location.name.toUpperCase() + a.item.category.name.toUpperCase() + a.item.name.toUpperCase() + a.expirationDate.toUpperCase();
        let nameB = b.location.name.toUpperCase() + b.item.category.name.toUpperCase() + b.item.name.toUpperCase() + b.expirationDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateInventoryFromItem(state, { id, item }) {
      const index = state.inventories.findIndex((element) => element.id === id);
      state.inventories[index].item.category.id = item.category.id;
      state.inventories[index].item.category.name = item.category.name;
      state.inventories[index].item.category.color = item.category.color;
      state.inventories[index].item.name = item.name;
      state.inventories[index].item.expirationDateManagement = item.expirationDateManagement;
      state.inventories[index].item.unitPurchasePriceManagement = item.unitPurchasePriceManagement;
      if (!item.expirationDateManagement) {
        state.inventories[index].expirationDate = "";
      }
      if (!item.unitPurchasePriceManagement) {
        state.inventories[index].unitPurchasePrice = "";
        state.inventories[index].store = "";
      }
      state.inventories.sort(function (a, b) {
        let nameA = a.location.name.toUpperCase() + a.item.category.name.toUpperCase() + a.item.name.toUpperCase() + a.expirationDate.toUpperCase();
        let nameB = b.location.name.toUpperCase() + b.item.category.name.toUpperCase() + b.item.name.toUpperCase() + b.expirationDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateInventoryFromCategory(state, { id, category }) {
      const index = state.inventories.findIndex((element) => element.id === id);
      state.inventories[index].item.category.name = category.name;
      state.inventories[index].item.category.color = category.color;
      state.inventories.sort(function (a, b) {
        let nameA = a.location.name.toUpperCase() + a.item.category.name.toUpperCase() + a.item.name.toUpperCase() + a.expirationDate.toUpperCase();
        let nameB = b.location.name.toUpperCase() + b.item.category.name.toUpperCase() + b.item.name.toUpperCase() + b.expirationDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateInventoryFromLocation(state, { id, location }) {
      const index = state.inventories.findIndex((element) => element.id === id);
      state.inventories[index].location.name = location.name;
      state.inventories.sort(function (a, b) {
        let nameA = a.location.name.toUpperCase() + a.item.category.name.toUpperCase() + a.item.name.toUpperCase() + a.expirationDate.toUpperCase();
        let nameB = b.location.name.toUpperCase() + b.item.category.name.toUpperCase() + b.item.name.toUpperCase() + b.expirationDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    deleteInventory(state, id) {
      const index = state.inventories.findIndex((element) => element.id === id);
      state.inventories.splice(index, 1);
    },
    plusMinusInventory(state, inventory) {
      const index = state.inventories.findIndex((element) => element.id === inventory.id);
      state.inventories[index].remainingQty = inventory.remainingQty;
    },
    addHistory(state, { id, inventoryId, inventory, entryType, entryDate }) {
      const year = entryDate.getFullYear();
      const month = entryDate.getMonth() + 1;
      const day = entryDate.getDate();
      const hours = entryDate.getHours();
      const minutes = entryDate.getMinutes();
      const seconds = entryDate.getSeconds();
      const formattedEntryDate =
        year +
        "-" +
        month.toString().padStart(2, "0") +
        "-" +
        day.toString().padStart(2, "0") +
        " " +
        hours.toString().padStart(2, "0") +
        ":" +
        minutes.toString().padStart(2, "0") +
        ":" +
        seconds.toString().padStart(2, "0");
      const element = {
        id: id,
        entryType: entryType,
        entryDate: formattedEntryDate,
        inventoryId: inventoryId,
        itemId: inventory.item.id,
        itemName: inventory.item.name,
        expirationDateManagement: inventory.item.expirationDateManagement,
        unitPurchasePriceManagement: inventory.item.unitPurchasePriceManagement,
        categoryId: inventory.item.category.id,
        categoryName: inventory.item.category.name,
        categoryColor: inventory.item.category.color,
        locationId: inventory.location.id,
        locationName: inventory.location.name,
        expirationDate: inventory.expirationDate,
        unitPurchasePrice: entryType === "在庫登録" ? inventory.unitPurchasePrice : "",
        store: entryType === "在庫登録" ? inventory.store : "",
        remainingQty: inventory.remainingQty,
        additionalQty: inventory.additionalQty === 0 ? "" : inventory.additionalQty,
      };
      state.histories.push(element);
      state.histories.sort(function (a, b) {
        let nameA = a.locationName.toUpperCase() + a.categoryName.toUpperCase() + a.itemName.toUpperCase() + a.expirationDate.toUpperCase() + a.entryDate.toUpperCase();
        let nameB = b.locationName.toUpperCase() + b.categoryName.toUpperCase() + b.itemName.toUpperCase() + b.expirationDate.toUpperCase() + b.entryDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    addHistoryFromDB(state, { id, localHistory }) {
      const year = localHistory.entryDate.toDate().getFullYear();
      const month = localHistory.entryDate.toDate().getMonth() + 1;
      const day = localHistory.entryDate.toDate().getDate();
      const hours = localHistory.entryDate.toDate().getHours();
      const minutes = localHistory.entryDate.toDate().getMinutes();
      const seconds = localHistory.entryDate.toDate().getSeconds();
      const formattedEntryDate =
        year +
        "-" +
        month.toString().padStart(2, "0") +
        "-" +
        day.toString().padStart(2, "0") +
        " " +
        hours.toString().padStart(2, "0") +
        ":" +
        minutes.toString().padStart(2, "0") +
        ":" +
        seconds.toString().padStart(2, "0");
      const element = {
        id: id,
        entryType: localHistory.entryType,
        entryDate: formattedEntryDate,
        inventoryId: localHistory.inventoryId,
        itemId: localHistory.itemId,
        itemName: localHistory.itemName,
        expirationDateManagement: localHistory.expirationDateManagement,
        unitPurchasePriceManagement: localHistory.unitPurchasePriceManagement,
        categoryId: localHistory.categoryId,
        categoryName: localHistory.categoryName,
        categoryColor: localHistory.categoryColor,
        locationId: localHistory.locationId,
        locationName: localHistory.locationName,
        expirationDate: localHistory.expirationDate,
        unitPurchasePrice: localHistory.entryType === "在庫登録" ? localHistory.unitPurchasePrice : "",
        store: localHistory.entryType === "在庫登録" ? localHistory.store : "",
        remainingQty: localHistory.remainingQty,
        additionalQty: localHistory.additionalQty === 0 ? "" : localHistory.additionalQty,
      };
      state.histories.push(element);
      state.histories.sort(function (a, b) {
        let nameA = a.locationName.toUpperCase() + a.categoryName.toUpperCase() + a.itemName.toUpperCase() + a.expirationDate.toUpperCase() + a.entryDate.toUpperCase();
        let nameB = b.locationName.toUpperCase() + b.categoryName.toUpperCase() + b.itemName.toUpperCase() + b.expirationDate.toUpperCase() + b.entryDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateHistoryFromItem(state, { id, item }) {
      const index = state.histories.findIndex((element) => element.id === id);
      state.histories[index].categoryId = item.category.id;
      state.histories[index].categoryName = item.category.name;
      state.histories[index].categoryColor = item.category.color;
      state.histories[index].itemName = item.name;
      state.histories[index].expirationDateManagement = item.expirationDateManagement;
      state.histories[index].unitPurchasePriceManagement = item.unitPurchasePriceManagement;
      if (!item.expirationDateManagement) {
        state.histories[index].expirationDate = "";
      }
      if (!item.unitPurchasePriceManagement) {
        state.histories[index].unitPurchasePrice = "";
        state.histories[index].store = "";
      }
      state.histories.sort(function (a, b) {
        let nameA = a.locationName.toUpperCase() + a.categoryName.toUpperCase() + a.itemName.toUpperCase() + a.expirationDate.toUpperCase() + a.entryDate.toUpperCase();
        let nameB = b.locationName.toUpperCase() + b.categoryName.toUpperCase() + b.itemName.toUpperCase() + b.expirationDate.toUpperCase() + b.entryDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateHistoryFromCategory(state, { id, category }) {
      const index = state.histories.findIndex((element) => element.id === id);
      state.histories[index].categoryName = category.name;
      state.histories[index].categoryColor = category.color;
      state.histories.sort(function (a, b) {
        let nameA = a.locationName.toUpperCase() + a.categoryName.toUpperCase() + a.itemName.toUpperCase() + a.expirationDate.toUpperCase() + a.entryDate.toUpperCase();
        let nameB = b.locationName.toUpperCase() + b.categoryName.toUpperCase() + b.itemName.toUpperCase() + b.expirationDate.toUpperCase() + b.entryDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    updateHistoryFromLocation(state, { id, location }) {
      const index = state.histories.findIndex((element) => element.id === id);
      state.histories[index].locationName = location.name;
      state.histories.sort(function (a, b) {
        let nameA = a.locationName.toUpperCase() + a.categoryName.toUpperCase() + a.itemName.toUpperCase() + a.expirationDate.toUpperCase() + a.entryDate.toUpperCase();
        let nameB = b.locationName.toUpperCase() + b.categoryName.toUpperCase() + b.itemName.toUpperCase() + b.expirationDate.toUpperCase() + b.entryDate.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    deleteHistory(state, id) {
      const index = state.histories.findIndex((element) => element.id === id);
      state.histories.splice(index, 1);
    },
  },
  actions: {
    toggleSideMenu({ commit }) {
      commit("toggleSideMenu");
    },
    login() {
      const provider = new GoogleAuthProvider();
      signInWithRedirect(auth, provider);
    },
    logout() {
      signOut(auth);
    },
    // setUserData
    async setLoginUser({ commit }, user) {
      commit("setLoginUser", user);
    },
    // resetUserData
    async deleteLoginUser({ commit }) {
      commit("deleteLoginUser");
    },
    // setUserData
    async addUser({ getters }) {
      if (getters.uid) {
        try {
          const docSnap = await getDoc(doc(db, "users", getters.uid));
          if (docSnap.exists()) {
            const docRef = doc(db, "users", getters.uid);
            await updateDoc(docRef, {
              lastLoginDate: Timestamp.now().toDate(),
            });
            console.log("Success: updateUser; userName:", getters.userName);
          } else {
            const docData = {
              userName: getters.userName,
              createdDate: Timestamp.now().toDate(),
            };
            await setDoc(doc(db, "users", getters.uid), docData);
            console.log("Success: addUser; userName:", getters.userName);
          }
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    // setUserData
    async fetchCategories({ getters, commit }) {
      const querySnapshot = await getDocs(collection(db, `users/${getters.uid}/categories`));
      querySnapshot.forEach((doc) => {
        commit("addCategory", { id: doc.id, category: doc.data() });
      });
    },
    async addCategory({ getters, commit }, category) {
      if (getters.uid) {
        try {
          const docData = {
            name: category.name,
            color: category.color,
            createdDate: Timestamp.now().toDate(),
          };
          const docRef = await addDoc(collection(db, `users/${getters.uid}/categories`), docData);
          console.log("Success: actions.addCategory; id:", docRef.id);
          commit("addCategory", { id: docRef.id, category: category });
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    async updateCategory({ getters, commit }, category) {
      if (getters.uid) {
        try {
          //updateCategory
          const docRef = doc(db, `users/${getters.uid}/categories`, category.id);
          await updateDoc(docRef, {
            name: category.name,
            color: category.color,
          });
          console.log("Success: updateCategory; categoryId:", category.id);
          commit("updateCategory", category);

          //updateItem
          let itemDocIds = [];
          const itemQuery = query(collection(db, `users/${getters.uid}/items`), where("categoryId", "==", category.id));
          const itemQuerySnapshot = await getDocs(itemQuery);
          itemQuerySnapshot.forEach((itemDoc) => {
            itemDocIds.push(itemDoc.id);
          });
          for (let i = 0; i < itemDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/items`, itemDocIds[i]), {
              categoryName: category.name,
              categoryColor: category.color,
            });
            console.log("Success: updateItem; categoryId:", category.id, " itemId:", itemDocIds[i]);
            commit("updateItemFromCategory", { id: itemDocIds[i], category: category });
          }

          //updateInventory
          let invDocIds = [];
          const invQuery = query(collection(db, `users/${getters.uid}/inventories`), where("categoryId", "==", category.id));
          const invQuerySnapshot = await getDocs(invQuery);
          invQuerySnapshot.forEach((invDoc) => {
            invDocIds.push(invDoc.id);
          });
          for (let i = 0; i < invDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/inventories`, invDocIds[i]), {
              categoryName: category.name,
              categoryColor: category.color,
            });
            console.log("Success: updateInventory; categoryId:", category.id, " inventoryId:", invDocIds[i]);
            commit("updateInventoryFromCategory", { id: invDocIds[i], category: category });
          }

          //updateHistory
          let histDocIds = [];
          const histQuery = query(collection(db, `users/${getters.uid}/histories`), where("categoryId", "==", category.id));
          const histQuerySnapshot = await getDocs(histQuery);
          histQuerySnapshot.forEach((histDoc) => {
            histDocIds.push(histDoc.id);
          });
          for (let i = 0; i < histDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/histories`, histDocIds[i]), {
              categoryName: category.name,
              categoryColor: category.color,
            });
            console.log("Success: updateHistory; categoryId:", category.id, " historyId:", histDocIds[i]);
            commit("updateHistoryFromCategory", { id: histDocIds[i], category: category });
          }
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    async deleteCategory({ getters, commit }, id) {
      if (getters.uid) {
        try {
          //deleteCategory
          await deleteDoc(doc(db, `users/${getters.uid}/categories`, id));
          console.log("Success: actions.deleteCategory; id:", id);
          commit("deleteCategory", id);

          //deleteItem
          let category = new Object();
          category.name = "";
          category.color = "";

          let itemDocIds = [];
          const itemQuery = query(collection(db, `users/${getters.uid}/items`), where("categoryId", "==", id));
          const itemQuerySnapshot = await getDocs(itemQuery);
          itemQuerySnapshot.forEach((itemDoc) => {
            itemDocIds.push(itemDoc.id);
          });
          for (let i = 0; i < itemDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/items`, itemDocIds[i]), {
              categoryName: category.name,
              categoryColor: category.color,
            });
            console.log("Success: updateItem; categoryId:", id, " itemId:", itemDocIds[i]);
            commit("updateItemFromCategory", { id: itemDocIds[i], category: category });
          }

          //deleteInventory
          let invDocIds = [];
          const invQuery = query(collection(db, `users/${getters.uid}/inventories`), where("categoryId", "==", id));
          const invQuerySnapshot = await getDocs(invQuery);
          invQuerySnapshot.forEach((invDoc) => {
            invDocIds.push(invDoc.id);
          });
          for (let i = 0; i < invDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/inventories`, invDocIds[i]), {
              categoryName: category.name,
              categoryColor: category.color,
            });
            console.log("Success: updateInventory; categoryId:", id, " inventoryId:", invDocIds[i]);
            commit("updateInventoryFromCategory", { id: invDocIds[i], category: category });
          }

          //deleteHistory
          let histDocIds = [];
          const histQuery = query(collection(db, `users/${getters.uid}/histories`), where("categoryId", "==", id));
          const histQuerySnapshot = await getDocs(histQuery);
          histQuerySnapshot.forEach((histDoc) => {
            histDocIds.push(histDoc.id);
          });
          for (let i = 0; i < histDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/histories`, histDocIds[i]), {
              categoryName: category.name,
              categoryColor: category.color,
            });
            console.log("Success: updateHistory; categoryId:", id, " historyId:", histDocIds[i]);
            commit("updateHistoryFromCategory", { id: histDocIds[i], category: category });
          }
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    // setUserData
    async fetchItems({ getters, commit }) {
      const querySnapshot = await getDocs(collection(db, `users/${getters.uid}/items`));
      querySnapshot.forEach((doc) => {
        commit("addItemFromDB", { id: doc.id, item: doc.data() });
      });
    },
    async addItem({ getters, commit }, item) {
      if (getters.uid) {
        try {
          const docData = {
            categoryId: item.category.id,
            categoryName: item.category.name,
            categoryColor: item.category.color,
            name: item.name,
            expirationDateManagement: item.expirationDateManagement,
            unitPurchasePriceManagement: item.unitPurchasePriceManagement,
            createdDate: Timestamp.now().toDate(),
          };
          const docRef = await addDoc(collection(db, `users/${getters.uid}/items`), docData);
          console.log("Success: actions.addItem; id:", docRef.id);
          commit("addItem", { id: docRef.id, item });
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    async updateItem({ getters, commit }, item) {
      if (getters.uid) {
        try {
          //updateItem
          const docRef = doc(db, `users/${getters.uid}/items`, item.id);
          await updateDoc(docRef, {
            categoryId: item.category.id,
            categoryName: item.category.name,
            categoryColor: item.category.color,
            name: item.name,
            expirationDateManagement: item.expirationDateManagement,
            unitPurchasePriceManagement: item.unitPurchasePriceManagement,
          });
          console.log("Success: updateItem; id:", item.id);
          commit("updateItem", item);

          //updateInventory
          let invDocIds = [];
          let invDocData = [];
          const invQuery = query(collection(db, `users/${getters.uid}/inventories`), where("itemId", "==", item.id));
          const invQuerySnapshot = await getDocs(invQuery);
          invQuerySnapshot.forEach((invDoc) => {
            invDocIds.push(invDoc.id);
            invDocData.push(invDoc.data());
          });
          for (let i = 0; i < invDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/inventories`, invDocIds[i]), {
              categoryId: item.category.id,
              categoryName: item.category.name,
              categoryColor: item.category.color,
              itemName: item.name,
              expirationDateManagement: item.expirationDateManagement,
              unitPurchasePriceManagement: item.unitPurchasePriceManagement,
              expirationDate: item.expirationDateManagement === false ? "" : invDocData[i].expirationDate,
              unitPurchasePrice: item.unitPurchasePriceManagement === false ? "" : invDocData[i].unitPurchasePrice,
              store: item.unitPurchasePriceManagement === false ? "" : invDocData[i].store,
            });
            console.log("Success: updateInventory; itemId:", item.id, " inventoryId:", invDocIds[i]);
            commit("updateInventoryFromItem", { id: invDocIds[i], item: item });
          }

          //updateHistory
          let histDocIds = [];
          let histDocData = [];
          const histQuery = query(collection(db, `users/${getters.uid}/histories`), where("itemId", "==", item.id));
          const histQuerySnapshot = await getDocs(histQuery);
          histQuerySnapshot.forEach((histDoc) => {
            histDocIds.push(histDoc.id);
            histDocData.push(histDoc.data());
          });
          for (let i = 0; i < histDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/histories`, histDocIds[i]), {
              categoryId: item.category.id,
              categoryName: item.category.name,
              categoryColor: item.category.color,
              itemName: item.name,
              expirationDateManagement: item.expirationDateManagement,
              unitPurchasePriceManagement: item.unitPurchasePriceManagement,
              expirationDate: item.expirationDateManagement === false ? "" : histDocData[i].expirationDate,
              unitPurchasePrice: item.unitPurchasePriceManagement === false ? "" : histDocData[i].unitPurchasePrice,
              store: item.unitPurchasePriceManagement === false ? "" : histDocData[i].store,
            });
            console.log("Success: updateHistory; itemId:", item.id, " historyId:", histDocIds[i]);
            commit("updateHistoryFromItem", { id: histDocIds[i], item: item });
          }
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    async deleteItem({ getters, commit }, id) {
      if (getters.uid) {
        try {
          //deleteItem
          await deleteDoc(doc(db, `users/${getters.uid}/items`, id));
          console.log("Success: deleteItem; itemId:", id);
          commit("deleteItem", id);

          //deleteInventory
          let invDocIds = [];
          const invQuery = query(collection(db, `users/${getters.uid}/inventories`), where("itemId", "==", id));
          const invQuerySnapshot = await getDocs(invQuery);
          invQuerySnapshot.forEach((invDoc) => {
            invDocIds.push(invDoc.id);
          });
          for (let i = 0; i < invDocIds.length; i++) {
            await deleteDoc(doc(db, `users/${getters.uid}/inventories`, invDocIds[i]));
            console.log("Success: deleteInventory; itemId:", id, " inventoryId:", invDocIds[i]);
            commit("deleteInventory", invDocIds[i]);
          }
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    // setUserData
    async fetchLocations({ getters, commit }) {
      const querySnapshot = await getDocs(collection(db, `users/${getters.uid}/locations`));
      querySnapshot.forEach((doc) => {
        commit("addLocation", { id: doc.id, location: doc.data() });
      });
    },
    async addLocation({ getters, commit }, location) {
      if (getters.uid) {
        try {
          const docData = {
            name: location.name,
            createdDate: Timestamp.now().toDate(),
          };
          const docRef = await addDoc(collection(db, `users/${getters.uid}/locations`), docData);
          console.log("Success: actions.addLocation; id:", docRef.id);
          commit("addLocation", { id: docRef.id, location: location });
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    async updateLocation({ getters, commit }, location) {
      if (getters.uid) {
        try {
          //updateLocation
          const docRef = doc(db, `users/${getters.uid}/locations`, location.id);
          await updateDoc(docRef, {
            name: location.name,
          });
          console.log("Success: updateLocation; locationId:", location.id);
          commit("updateLocation", location);

          //updateInventory
          let invDocIds = [];
          const invQuery = query(collection(db, `users/${getters.uid}/inventories`), where("locationId", "==", location.id));
          const invQuerySnapshot = await getDocs(invQuery);
          invQuerySnapshot.forEach((invDoc) => {
            invDocIds.push(invDoc.id);
          });
          for (let i = 0; i < invDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/inventories`, invDocIds[i]), {
              locationName: location.name,
            });
            console.log("Success: updateInventory; locationId:", location.id, " inventoryId:", invDocIds[i]);
            commit("updateInventoryFromLocation", { id: invDocIds[i], location: location });
          }

          //updateHistory
          let histDocIds = [];
          const histQuery = query(collection(db, `users/${getters.uid}/histories`), where("locationId", "==", location.id));
          const histQuerySnapshot = await getDocs(histQuery);
          histQuerySnapshot.forEach((histDoc) => {
            histDocIds.push(histDoc.id);
          });
          for (let i = 0; i < histDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/histories`, histDocIds[i]), {
              locationName: location.name,
            });
            console.log("Success: updateHistory; locationId:", location.id, " historyId:", histDocIds[i]);
            commit("updateHistoryFromLocation", { id: histDocIds[i], location: location });
          }
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    async deleteLocation({ getters, commit }, id) {
      if (getters.uid) {
        try {
          //deleteLocation
          await deleteDoc(doc(db, `users/${getters.uid}/locations`, id));
          console.log("Success: actions.deleteLocation; id:", id);
          commit("deleteLocation", id);

          let location = new Object();
          location.name = "";

          //deleteInventory
          let invDocIds = [];
          const invQuery = query(collection(db, `users/${getters.uid}/inventories`), where("locationId", "==", id));
          const invQuerySnapshot = await getDocs(invQuery);
          invQuerySnapshot.forEach((invDoc) => {
            invDocIds.push(invDoc.id);
          });
          for (let i = 0; i < invDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/inventories`, invDocIds[i]), {
              locationName: location.name,
            });
            console.log("Success: updateInventory; locationId:", id, " inventoryId:", invDocIds[i]);
            commit("updateInventoryFromLocation", { id: invDocIds[i], location: location });
          }

          //deleteHistory
          let histDocIds = [];
          const histQuery = query(collection(db, `users/${getters.uid}/histories`), where("locationId", "==", id));
          const histQuerySnapshot = await getDocs(histQuery);
          histQuerySnapshot.forEach((histDoc) => {
            histDocIds.push(histDoc.id);
          });
          for (let i = 0; i < histDocIds.length; i++) {
            await updateDoc(doc(db, `users/${getters.uid}/histories`, histDocIds[i]), {
              locationName: location.name,
            });
            console.log("Success: updateHistory; locationId:", id, " historyId:", histDocIds[i]);
            commit("updateHistoryFromLocation", { id: histDocIds[i], location: location });
          }
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    // setUserData
    async fetchInventories({ getters, commit }) {
      const querySnapshot = await getDocs(collection(db, `users/${getters.uid}/inventories`));
      querySnapshot.forEach((doc) => {
        commit("addInventoryFromDB", { id: doc.id, inventory: doc.data() });
      });
    },
    async addInventoryAndHistory({ getters, commit }, inventory) {
      if (getters.uid) {
        try {
          const entryDate = Timestamp.now().toDate();
          const entryType = "在庫登録";

          //addInventory
          const invDocData = {
            entryDate: inventory.entryDate,
            itemId: inventory.item.id,
            itemName: inventory.item.name,
            expirationDateManagement: inventory.item.expirationDateManagement,
            unitPurchasePriceManagement: inventory.item.unitPurchasePriceManagement,
            categoryId: inventory.item.category.id,
            categoryName: inventory.item.category.name,
            categoryColor: inventory.item.category.color,
            locationId: inventory.location.id,
            locationName: inventory.location.name,
            expirationDate: inventory.expirationDate,
            unitPurchasePrice: inventory.unitPurchasePrice,
            store: inventory.store,
            remainingQty: inventory.remainingQty,
            additionalQty: inventory.additionalQty,
            createdDate: entryDate,
          };
          const invDocRef = await addDoc(collection(db, `users/${getters.uid}/inventories`), invDocData);
          console.log("Success: addInventory; id:", invDocRef.id);
          commit("addInventory", { id: invDocRef.id, inventory });

          //addHistory
          const histDocData = {
            entryType: entryType,
            entryDate: entryDate,
            inventoryId: invDocRef.id,
            itemId: inventory.item.id,
            itemName: inventory.item.name,
            expirationDateManagement: inventory.item.expirationDateManagement,
            unitPurchasePriceManagement: inventory.item.unitPurchasePriceManagement,
            categoryId: inventory.item.category.id,
            categoryName: inventory.item.category.name,
            categoryColor: inventory.item.category.color,
            locationId: inventory.location.id,
            locationName: inventory.location.name,
            expirationDate: inventory.expirationDate,
            unitPurchasePrice: inventory.unitPurchasePrice,
            store: inventory.store,
            remainingQty: inventory.remainingQty,
            additionalQty: inventory.additionalQty === 0 ? "" : inventory.additionalQty,
          };
          const histDocRef = await addDoc(collection(db, `users/${getters.uid}/histories`), histDocData);
          console.log("Success: addHistory; id:", histDocRef.id);
          commit("addHistory", { id: histDocRef.id, inventoryId: invDocRef.id, inventory: inventory, entryType: entryType, entryDate: entryDate });
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    async plusMinusInventoryAndHistory({ getters, commit }, inventory) {
      if (getters.uid) {
        try {
          const entryDate = Timestamp.now().toDate();
          const entryType = inventory.additionalQty > 0 ? "補充登録" : "消費登録";

          //plusMinusInventory
          const invDocRef = doc(db, `users/${getters.uid}/inventories`, inventory.id);
          await updateDoc(invDocRef, {
            remainingQty: inventory.remainingQty,
          });
          console.log("Success: plusMinusInventory; id:", inventory.id);
          commit("plusMinusInventory", inventory);

          //addHistory
          const histDocData = {
            entryType: entryType,
            entryDate: entryDate,
            inventoryId: inventory.id,
            itemId: inventory.item.id,
            itemName: inventory.item.name,
            expirationDateManagement: inventory.item.expirationDateManagement,
            unitPurchasePriceManagement: inventory.item.unitPurchasePriceManagement,
            categoryId: inventory.item.category.id,
            categoryName: inventory.item.category.name,
            categoryColor: inventory.item.category.color,
            locationId: inventory.location.id,
            locationName: inventory.location.name,
            expirationDate: inventory.expirationDate,
            unitPurchasePrice: inventory.unitPurchasePrice,
            store: inventory.store,
            remainingQty: inventory.remainingQty,
            additionalQty: inventory.additionalQty,
          };
          const histDocRef = await addDoc(collection(db, `users/${getters.uid}/histories`), histDocData);
          console.log("Success: addHistory; id:", histDocRef.id);
          commit("addHistory", { id: histDocRef.id, inventoryId: inventory.id, inventory: inventory, entryType: entryType, entryDate: entryDate });
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    async deleteInventoryAndHistory({ getters, commit }, id) {
      if (getters.uid) {
        try {
          //deleteInventory
          await deleteDoc(doc(db, `users/${getters.uid}/inventories`, id));
          console.log("Success: actions.deleteInventory; id:", id);
          commit("deleteInventory", id);
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
    // setUserData
    async fetchHistories({ getters, commit }) {
      const historiesSnapshot = await getDocs(collection(db, `users/${getters.uid}/histories`));
      historiesSnapshot.forEach((doc) => {
        commit("addHistoryFromDB", { id: doc.id, localHistory: doc.data() });
      });
    },
    async deleteHistory({ getters, commit }, id) {
      if (getters.uid) {
        try {
          //deleteHistory
          await deleteDoc(doc(db, `users/${getters.uid}/histories`, id));
          console.log("Success: deleteHistory; id:", id);
          commit("deleteHistory", id);
        } catch (e) {
          console.error("Error: ", e);
        }
      }
    },
  },
  getters: {
    userName: (state) => (state.login_user ? state.login_user.displayName : ""),
    photoURL: (state) => (state.login_user ? state.login_user.photoURL : ""),
    uid: (state) => (state.login_user ? state.login_user.uid : null),
    itemLength: (state) => {
      return state.items.length;
    },
  },
});
